import { createUrl } from '@common/utils/url/create-url';
import { BACKEND_URL } from 'src/constants';
import { StorageService } from 'src/services/StorageService';
import { makeAsyncCall } from 'src/utils';

const index = ({
  filter,
  sort,
  perPage,
  page,
  include,
}: {
  filter?: object;
  sort?: string;
  perPage?: number;
  page?: number;
  include?: string;
}) =>
  makeAsyncCall({
    url: createUrl('spaces', filter, sort, perPage, page, include),
    method: 'GET',
  });

const store = data =>
  makeAsyncCall({
    url: `${BACKEND_URL}spaces`,
    method: 'POST',
    body: JSON.stringify(data),
  });

const show = (id: number) =>
  makeAsyncCall({
    url: `${BACKEND_URL}spaces/${id}`,
    method: 'GET',
  });

const update = (id: number, data) => {
  return Promise.all([
    data.terms_of_use_pdf
      ? StorageService.uploadFile(data.terms_of_use_pdf)
      : new Promise<void>(resolve => resolve()),
    data.favicon
      ? StorageService.uploadFile(data.favicon)
      : new Promise<void>(resolve => resolve()),
    data.logo
      ? StorageService.uploadFile(data.logo)
      : new Promise<void>(resolve => resolve()),
    data.portalHeader
      ? StorageService.uploadFile(data.portalHeader)
      : new Promise<void>(resolve => resolve()),
  ]).then(values => {
    delete data['terms_of_use_pdf'];
    if (values[0]) {
      data['terms_of_use_pdf_path'] = values[0];
    }
    if (values[1]) {
      data['favicon_path'] = values[1];
    }
    if (values[2]) {
      data['logo_path'] = values[2];
    }
    if (values[3]) {
      data['portal_header_path'] = values[3];
    }
    return makeAsyncCall({
      url: `${BACKEND_URL}spaces/${id}`,
      method: 'PUT',
      body: JSON.stringify(data),
    });
  });
};

const detachAdmin = (spaceId: number, userId) =>
  makeAsyncCall({
    url: `${BACKEND_URL}spaces/${spaceId}/admins/${userId}`,
    method: 'DELETE',
  });

const attachAdmin = (spaceId: number, data) =>
  makeAsyncCall({
    url: `${BACKEND_URL}spaces/${spaceId}/admins`,
    method: 'POST',
    body: JSON.stringify(data),
  });

const flushTranslationCache = () =>
  makeAsyncCall({
    url: `${BACKEND_URL}locales/flush`,
    method: 'POST',
  });

export const SpaceService = {
  index: (query: {
    filter?: object;
    sort?: string;
    perPage?: number;
    page?: number;
    include?: string;
  }) => index(query),
  store: data => store(data),
  show: (id: number) => show(id),
  update: (id: number, data) => update(id, data),
  detachAdmin: (spaceId: number, userId: number) => detachAdmin(spaceId, userId),
  attachAdmin: (spaceId: number, data) => attachAdmin(spaceId, data),
  flushTranslationCache: () => flushTranslationCache(),
};
